'use strict';

import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals/attribution';

(function () {
  var config = window.__mpi && window.__mpi.cwvReporter;
  if (!config || !config.routeId) return;

  var routeId = config.routeId;
  var deviceType = config.deviceType || 'desktop';

  function getBrowserEngine() {
    var ua = navigator.userAgent;
    if (ua.indexOf('Firefox') !== -1) return 'Gecko';
    if (ua.indexOf('Edg/') !== -1) return 'Blink';
    if (ua.indexOf('Chrome') !== -1) return 'Blink';
    if (ua.indexOf('Safari') !== -1) return 'WebKit';
    return 'unknown';
  }

  function getTarget(name, attribution) {
    switch (name) {
      case 'CLS': return attribution.largestShiftTarget;
      case 'LCP': return attribution.target;
      default: return attribution.interactionTarget;
    }
  }

  function waitForMushroom(cb, retries) {
    if (globalThis.__mushroomInstance) return cb(globalThis.__mushroomInstance);
    if (!retries) return;
    setTimeout(function () { waitForMushroom(cb, retries - 1); }, 100);
  }

  waitForMushroom(function (instance) {
    var tracker = instance.Trackers.create('adv.logger', {
      userAgent: navigator.userAgent,
      url: location.href
    });

    var engine = getBrowserEngine();
    var baseTags = [
      { key: 'routeid', value: routeId },
      { key: 'type', value: deviceType },
      { key: 'is_bot', value: false },
      { key: 'browserEngine', value: engine }
    ];

    function emitDistribution(metricName, amount) {
      tracker.emit('DISTRIBUTION', {
        name: 'cwv',
        amount: amount,
        tags: [{ key: 'name', value: metricName }, ...baseTags],
        url: location.href
      });
    }

    function handleMetric(metric) {
      var name = metric.name;
      var attribution = metric.attribution || {};
      var value = name === 'CLS' ? Math.round(metric.value * 1000) : Math.round(metric.value);
      var rating = metric.rating;

      emitDistribution(name.toLowerCase(), value);

      // INP subparts
      if (name === 'INP' && attribution) {
        var id = Math.round(attribution.inputDelay || 0);
        var pt = Math.round(attribution.processingDuration || 0);
        var pd = Math.round(attribution.presentationDelay || 0);
        if (id > 0) emitDistribution('id', id);
        if (pt > 0) emitDistribution('pt', pt);
        if (pd > 0) emitDistribution('pd', pd);
      }

      // LCP subparts
      if (name === 'LCP' && attribution) {
        var ttfb = Math.round(attribution.timeToFirstByte || 0);
        var rlde = Math.round(attribution.resourceLoadDelay || 0);
        var rldu = Math.round(attribution.resourceLoadDuration || 0);
        var erde = Math.round(attribution.elementRenderDelay || 0);
        if (ttfb > 0) emitDistribution('lcp_ttfb', ttfb);
        if (rlde > 0) emitDistribution('lcp_rlde', rlde);
        if (rldu > 0) emitDistribution('lcp_rldu', rldu);
        if (erde > 0) emitDistribution('lcp_erde', erde);
      }

      if (rating !== 'good') {
        var target = getTarget(name, attribution);
        var log = {
          name: 'cwv.' + name.toLowerCase(),
          amount: value,
          path: location.pathname,
          visibilityState: document.visibilityState,
          url: location.href
        };
        if (routeId) log.routeId = routeId;
        if (target) log.target = target;
        if (attribution.loadState) log.loadState = attribution.loadState;
        if (attribution.interactionType) log.eventType = attribution.interactionType;
        if (navigator.deviceMemory) log.deviceMemory = navigator.deviceMemory;
        if (navigator.connection && navigator.connection.effectiveType) log.effectiveType = navigator.connection.effectiveType;
        if (navigator.hardwareConcurrency) log.hardwareConcurrency = navigator.hardwareConcurrency;
        tracker.emit('PERFORMANCE_LOG', log);
      }
    }

    onCLS(handleMetric);
    onFCP(handleMetric);
    onINP(handleMetric);
    onLCP(handleMetric);
    onTTFB(handleMetric);
  }, 20);
})();
